import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/BusOneWay.png'


const _hoisted_1 = { class: "px-4" }
const _hoisted_2 = { class: "select-agent flex items-start lg:mb-6 md:mb-6 mb-0 flex-wrap" }
const _hoisted_3 = { class: "p-fluid flex items-center lg:w-1/2 md:w-1/2 w-full mb-4 lg:mb-0 md:mb-0" }
const _hoisted_4 = { class: "p-field w-full" }
const _hoisted_5 = { class: "flex items-center w-full mb-2" }
const _hoisted_6 = { class: "flex-1" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", {
  for: "province",
  class: "pb-1"
}, "Agent Berangkat Dari", -1)
const _hoisted_8 = {
  class: "py-2 px-2",
  style: {"border":"1px solid #ced4da","display":"flex","border-radius":"3px","padding":"0.5rem mb-1"}
}
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "justify-center items-center w-1/4 mx-4 lg:flex md:flex hidden" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_10 = { class: "md:w-3/4 lg:w-3/4 w-full md:text-base lg:text-base text-sm" }
const _hoisted_11 = { class: "p-fluid flex items-start flex-wrap lg:w-1/2 md:w-1/2 w-full mb-4 lg:mb-0 md:mb-0" }
const _hoisted_12 = { class: "p-field lg:w-2/3 md:w-2/3 w-full" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { for: "agentId" }, "Agent Tujuan Pengiriman", -1)
const _hoisted_14 = { class: "flex " }
const _hoisted_15 = { class: "flex-grow h-16 font-bold color-primary lg:text-base md:text-sm text-sm " }
const _hoisted_16 = {
  key: 0,
  class: "flex-grow-0 h-16 "
}
const _hoisted_17 = { class: "text-white font-bold lg:text-base md:text-sm text-sm" }
const _hoisted_18 = { class: "w-full md:text-base lg:text-base text-sm" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "flex items-center p-4" }, [
  /*#__PURE__*/_createVNode("p", { class: "mr-2 text-subtitle1" }, "Pilih Jadwal"),
  /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
    /*#__PURE__*/_createVNode("i", { class: "pi pi-info-circle text-sm color-blue-grey-darken-1 mr-2" }),
    /*#__PURE__*/_createVNode("p", { class: "color-blue-grey-darken-1 text-sm" }, "Pilih Tujuan Pengiriman Dahulu")
  ])
], -1)
const _hoisted_20 = { class: "flex items-center action-button" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "flex items-center justify-center" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-check text-sm text-white mr-2" }),
  /*#__PURE__*/_createVNode("span", { class: "text-white" }, "Terpilih")
], -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "mx-auto" }, "Pilih", -1)
const _hoisted_23 = { class: "background-green-lighten-5 px-3 py-1 flex items-center border-radius-blue-grey-darken-1 text-center justify-center" }
const _hoisted_24 = {
  key: 0,
  style: {"color":"#546E7A"}
}
const _hoisted_25 = {
  key: 0,
  class: "pi pi-info-circle text-sm color-blue-grey-darken-1 mr-3"
}
const _hoisted_26 = { class: "action-button" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Selanjutnya")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Batalkan")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabsDay = _resolveComponent("TabsDay")
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")
  const _component_DialogPriceCompanyRetail = _resolveComponent("DialogPriceCompanyRetail")
  const _component_DialogSearchAgen = _resolveComponent("DialogSearchAgen")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode("div", _hoisted_8, [
                _createVNode("span", null, _toDisplayString(_ctx.fromAgent), 1)
              ])
            ]),
            _hoisted_9
          ]),
          _createVNode("p", _hoisted_10, _toDisplayString(_ctx.store.getters['appActiveUser/getAgent'].address), 1)
        ])
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, _toDisplayString((_ctx.toAgentName.length > 0 ? _ctx.toAgentName : '...')), 1),
            (!_ctx.isMiisi)
              ? (_openBlock(), _createBlock("div", _hoisted_16, [
                  _createVNode("button", {
                    class: "flex-auto p-button p-component p-button p-button-sm rounded-lg flex items-center py-1 px-2 btn-primary",
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toogleSAgen = !_ctx.toogleSAgen))
                  }, [
                    _createVNode("span", _hoisted_17, _toDisplayString((_ctx.toAgentName.length > 0 ? 'Ubah Agen' : 'Pilih Agen')), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("p", _hoisted_18, _toDisplayString(_ctx.addressToAgent), 1)
        ])
      ])
    ]),
    _createVNode(_component_TabsDay, {
      class: "mb-3",
      onTabsChange: _ctx.changeTabs
    }, null, 8, ["onTabsChange"]),
    _createVNode(_component_Card, { class: "card-no-shadow card-p-0 mb-8" }, {
      content: _withCtx(() => [
        _hoisted_19,
        _createVNode(_component_DataTable, {
          value: _ctx.listSchedule,
          class: "table-og body-td-x-0",
          responsiveLayout: "scroll"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, { header: "No" }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", {
                  class: ["font-semibold text-black px-4  flex items-center", _ctx.activeStyle(slotProps.data.JadwalId)],
                  onClick: ($event: any) => (_ctx.selectedSchedule(slotProps.data.JadwalId))
                }, _toDisplayString(slotProps.data.No), 11, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Pilih" }, {
              body: _withCtx((slotProps) => [
                _createVNode("div", {
                  class: ["px-4  flex items-center", _ctx.activeStyle(slotProps.data.JadwalId)]
                }, [
                  _createVNode("div", _hoisted_20, [
                    (slotProps.data.JadwalId == _ctx.scheduleId)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          class: "btn-primary py-1 text-sm text-white w-24",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedSchedule(0)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_21
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_Button, {
                          key: 1,
                          class: "btn-secondary py-1 text-sm color-blue-grey w-24 text-center",
                          onClick: ($event: any) => (_ctx.selectedSchedule(slotProps.data.JadwalId))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_22
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                  ])
                ], 2)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Jadwal",
              field: "Jadwal"
            }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", {
                  class: ["text-black font-semibold w-44 sm:w-auto px-4  flex items-center", _ctx.activeStyle(slotProps.data.JadwalId)],
                  onClick: ($event: any) => (_ctx.selectedSchedule(slotProps.data.JadwalId))
                }, _toDisplayString(slotProps.data.Jadwal), 11, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Keberangkatan" }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", {
                  class: ["text-black text-sm font-semibold px-4  flex items-center", _ctx.activeStyle(slotProps.data.JadwalId)],
                  onClick: ($event: any) => (_ctx.selectedSchedule(slotProps.data.JadwalId))
                }, _toDisplayString(_ctx.moment(slotProps.data.Keberangkatan).format('HH:mm')) + " WIB", 11, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Bagasi",
              field: "JenisBus"
            }, {
              body: _withCtx((slotProps) => [
                _createVNode("div", {
                  class: "px-4 flex items-center",
                  onClick: ($event: any) => (_ctx.selectedSchedule(slotProps.data.JadwalId))
                }, [
                  _createVNode("div", _hoisted_23, [
                    _createVNode("span", {
                      class: ["font-semibold text-xs text-sm lg:text-base", _ctx.activeStyle(slotProps.data.JadwalId)]
                    }, "BUS " + _toDisplayString(slotProps.data.JenisBus), 3)
                  ])
                ], 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Rit" }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", {
                  class: ["text-black font-semibold px-4  flex items-center", _ctx.activeStyle(slotProps.data.JadwalId)],
                  onClick: ($event: any) => (_ctx.selectedSchedule(slotProps.data.JadwalId))
                }, _toDisplayString(slotProps.data.Rit), 11, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Pengiriman" }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", {
                  class: ["text-black text-xs font-semibold px-4  flex items-center", _ctx.activeStyle(slotProps.data.JadwalId)],
                  onClick: ($event: any) => (_ctx.selectedSchedule(slotProps.data.JadwalId))
                }, _toDisplayString(slotProps.data.Pengiriman), 11, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, null, {
              header: _withCtx(() => [
                (_ctx.checkPermission(_ctx.PermissionEnum.ShowNom))
                  ? (_openBlock(), _createBlock("p", _hoisted_24, "Pendapatan"))
                  : _createCommentVNode("", true)
              ]),
              body: _withCtx((slotProps) => [
                _createVNode("p", {
                  class: ["text-black font-semibold px-4  flex items-center", _ctx.activeStyle(slotProps.data.JadwalId)],
                  onClick: ($event: any) => (_ctx.selectedSchedule(slotProps.data.JadwalId))
                }, _toDisplayString(_ctx.checkPermission(_ctx.PermissionEnum.ShowNom) ? `Rp.
                ${(new Number(slotProps.data.Pendapatan).toLocaleString("id-ID"))}` : ''), 11, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, null, {
              body: _withCtx((slotProps) => [
                (slotProps.data.Attribute1)
                  ? _withDirectives((_openBlock(), _createBlock("i", _hoisted_25, null, 512)), [
                      [
                        _directive_tooltip,
                        slotProps.data.Attribute1,
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_26, [
      _createVNode(_component_Button, {
        class: "btn-primary text-black mr-3 px-10 py-1",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submitData()))
      }, {
        default: _withCtx(() => [
          _hoisted_27
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "btn-secondary text-black px-10 py-1",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submitBack()))
      }, {
        default: _withCtx(() => [
          _hoisted_28
        ]),
        _: 1
      })
    ]),
    (_ctx.dialogPrice)
      ? (_openBlock(), _createBlock(_component_DialogPriceCompanyRetail, {
          key: 0,
          fromCityId: _ctx.store.getters['appActiveUser/getAgent'].kotaId,
          toCityId: _ctx.toCityId,
          isShowDialog: _ctx.dialogPrice,
          onHideDialog: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hideDialog()))
        }, null, 8, ["fromCityId", "toCityId", "isShowDialog"]))
      : _createCommentVNode("", true),
    (_ctx.toogleSAgen)
      ? (_openBlock(), _createBlock(_component_DialogSearchAgen, {
          key: 1,
          isShowDialog: _ctx.toogleSAgen,
          onHideDialog: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toogleModalSearchAgen())),
          onSendOutData: _ctx.getSearchAgenData
        }, null, 8, ["isShowDialog", "onSendOutData"]))
      : _createCommentVNode("", true)
  ]))
}